import { combineReducers } from "redux";
import personReducer from "./store/person";

 const rootReducer = combineReducers({
    person: personReducer
 })

export default rootReducer 